<script>
    import debounce from "lodash/debounce";

    export default {
        name: "UrlQueryHandler",

        provide() {
            return {
                urlQueryHandler: {
                    registerRule: this.registerRule,
                    updateRuleValue: this.updateRuleValue,
                    queryMap: () => this.queryMap
                }
            }
        },

        data() {
            return {
                rules: [],
                queryMap: {}
            }
        },

        render() {
            return this.$slots.default || this.$slots.default;
        },

        created() {
            for (const [key, value] of new URL(window.location.href).searchParams) {
                let parsedValue = value;

                if (value === 'true') {
                    parsedValue = true;
                }

                this.$set(this.queryMap, key, parsedValue);
            }
        },

        watch: {
            queryMap: {
                deep: true,
                handler(to) {
                    this.updateUrl(to);
                }
            },
        },

        methods: {
            updateUrl: debounce(function (to) {
                let searchParamsString = Object.keys(to)
                    .reduce((url, key) => url + (to[key] !== undefined && to[key] !== null && to[key].toString().trim().length > 0 ? `&${key}=${to[key]}` : ''), '?')
                    .replace(/^\?&/g, '?');

                if (searchParamsString.trim() === '?') {
                    searchParamsString = '';
                }

                if (decodeURIComponent(window.location.href) !== (location.protocol + '//' + location.host + location.pathname + searchParamsString)) {
                    if (this.$router) {
                        this.$router.replace(searchParamsString);
                    } else {
                        history.replaceState(
                            null,
                            null,
                            location.protocol + '//' + location.host + location.pathname + searchParamsString
                        );
                    }
                }
            }, 500),

            registerRule(rule, value) {
                if (this.rules.indexOf(rule) < 0) {
                    this.rules.push(rule);

                    if (this.queryMap[rule.name] === undefined) {
                        this.$set(this.queryMap, rule.name, value);
                    }

                    rule.$once(
                        'hook:destroyed',
                        () => this.unregisterRule(rule)
                    );
                }
            },

            unregisterRule(rule) {
                this.rules = this.rules.slice().filter(r => r !== rule);
                this.$set(this.queryMap, rule.name, undefined);
            },

            updateRuleValue(rule, value) {
                this.$set(this.queryMap, rule.name, value);
            }
        }
    }
</script>